// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instance {
  position: relative;
  padding: 20px;
  min-height: 40px;
  line-height: 20px;
  border: 2px solid #d4cfbe;
  border-left: 5px solid #b39841;
  margin-top: 5px;
  display: flex;
  align-items: center;
}
.instance .instance-details {
  display: flex;
  width: 85%;
}
.instance .instance-details p {
  margin-bottom: 5px;
}
.instance .instance-details-text {
  font-family: 'Montserrat-Regular', sans-serif;
  margin-left: 10px;
  width: 100%;
}
.instance.collapsed .collapse-arrow .arrow {
  transform: none;
}
.instance.collapsed .collapsible-content {
  display: none;
}
.instance .collapse-arrow {
  display: flex;
  align-items: center;
  width: 30px;
}
.instance .collapse-arrow .arrow {
  background-image: url('closed-chev-big.847c1b52d4b4a306.svg');
  width: 24px;
  height: 24px;
  position: absolute;
  transform: rotate(180deg);
  outline: 0;
  text-shadow: none;
}
.instance .collapse-arrow .arrow:hover {
  cursor: pointer;
}
.instance .collapse-arrow .arrow:hover,
.instance .collapse-arrow .arrow:focus,
.instance .collapse-arrow .arrow:active {
  outline: 1px solid;
  outline: auto -webkit-focus-ring-color;
  outline-color: #b39841;
}
.instance .buttons {
  position: absolute;
  display: inline-block;
  right: 0;
  margin-right: 20px;
}
.collapsible-content-wrap {
  font-family: 'Montserrat-Light', sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #444444;
  padding: 20px 20px 20px 73px;
  background-color: #ece9dd;
  border: 2px solid transparent;
  border-top-style: none;
  border-left-width: 5px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/expandable-instance/expandable-instance.component.less"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AADF;AARA;EAYI,aAAA;EACA,UAAA;AADJ;AAZA;EAgBM,kBAAA;AADN;AAfA;EAoBI,6CAAA;EACA,iBAAA;EACA,WAAA;AAFJ;AAKE;EAGM,eAAA;AALR;AAEE;EAOI,aAAA;AANN;AA1BA;EAqCI,aAAA;EACA,mBAAA;EACA,WAAA;AARJ;AA/BA;EAyCM,6DAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;AAPN;AASM;EACE,eAAA;AAPR;AA3CA;;;EAwDM,kBAAA;EACA,sCAAA;EACA,sBAAA;AARN;AAlDA;EA+DI,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;AAVJ;AAcA;EACE,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;EACA,yBAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;AAZF","sourcesContent":["@import (reference) '../../styles/variables.less';\n\n.instance {\n  position: relative;\n  padding: 20px;\n  min-height: 40px;\n  line-height: 20px;\n  border: 2px solid @primary-50;\n  border-left: 5px solid @primary-90;\n  margin-top: 5px;\n  display: flex;\n  align-items: center;\n\n  .instance-details {\n    display: flex;\n    width: 85%;\n\n    p {\n      margin-bottom: 5px;\n    }\n  }\n  .instance-details-text{\n    font-family: 'Montserrat-Regular', sans-serif;\n    margin-left: 10px;\n    width: 100%;\n  }\n\n  &.collapsed {\n    .collapse-arrow {\n      .arrow {\n        transform: none;\n      }\n    }\n    .collapsible-content {\n      display: none;\n    }\n  }\n\n  .collapse-arrow {\n    display: flex;\n    align-items: center;\n    width: 30px;\n    .arrow {\n      background-image: url('../../styles/img/closed-chev-big.svg');\n      width: 24px;\n      height: 24px;\n      position: absolute;\n      transform: rotate(180deg);\n      outline: 0;\n      text-shadow: none;\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n    .arrow:hover,\n    .arrow:focus,\n    .arrow:active {\n      outline: 1px solid;\n      outline: auto -webkit-focus-ring-color;\n      outline-color: @primary-90;\n    }\n  }\n\n  .buttons {\n    position: absolute;\n    display: inline-block;\n    right: 0;\n    margin-right: 20px;\n  }\n}\n\n.collapsible-content-wrap {\n  font-family: 'Montserrat-Light', sans-serif;\n  font-size: 15px;\n  line-height: 20px;\n  color: @secondary-90;\n  padding: 20px 20px 20px 73px;\n  background-color: @neutral-background-light;\n  border: 2px solid transparent;\n  border-top-style: none;\n  border-left-width: 5px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
